import React, { useEffect } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import styles from "../../../../styles/pages/user/copyrwriterdashboard_dev/copywriter-myaccount.module.scss";

import { useState } from "react";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useNotiStack from "../../../../hooks/useNotistack";
import { usecopywriterschangepassword } from "../../../../hooks/api/useUser";

const schema = yup.object().shape({
  oldpassword: yup.string().nullable().required("Current Password is required"),

  password: yup
    .string()
    .required("New Password is required")
    .min(16, "Password must be at least 16 characters"),
  confpassword: yup
    .string()
    // .required("Password is required")
    .oneOf(
      [yup.ref("password")],
      "New password and confirmation do not match. Please re-enter them."
    ),
});

function ChnagePassword() {
  const { toastError } = useNotiStack();
  const {
    handleSubmit,
    register,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    values: {
      oldpassword: null,
      password: null,
      confpassword: null,
    },
  });
  // const onSubmit = (data ) => console.warn(data);

  const { mutate } = usecopywriterschangepassword();

  const passwordWatch = watch("oldpassword");
  const passwordWatch1 = watch("password");
  const passwordWatch2 = watch("confpassword");
  const [password, setpassword] = useState("");

  const [confPassword, setconfPassword] = useState(passwordWatch2);

  useEffect(() => {
    setpassword(passwordWatch1);

    setconfPassword(passwordWatch2);
  }, []);

  const onSubmit = (data, e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("old_password", passwordWatch);
    formData.append("password", data?.password);
    formData.append("password_confirmation", data?.confpassword);
    mutate(formData, {
      onSuccess: () => {
        reset();
        // window.location.reload();
        // password();
        // confPassword();
        // if (res?.message === "Password changed successfully") {
        //   // navigate("/login");
        // }
      },
      onError: (res) => {
        toastError(res?.response?.data?.message);
        window.location.reload();
        // password("");
        // confPassword("");
      },
    });
  };

  return (
    <>
      <Box className={styles.email_details_inputsec_inner}>
        <Typography
          variant="h4"
          className={`${styles.profile_upload_head} ${styles.neww}`}
        >
          Password
        </Typography>
        <Box className={styles.gap_wrapper_emltb}>
          <Grid
            container
            rowSpacing={2.75}
            columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
          >
            <Grid item xs={12}>
              <Grid
                container
                rowSpacing={2.75}
                columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
              >
                <Grid item lg={3.98} xs={12}>
                  <Box className={styles.namedetails_input}>
                    <Typography
                      variant="h6"
                      className={`${styles.heading_label} ${styles.newl_label}`}
                    >
                      Current password
                    </Typography>
                    <TextField type="text" {...register("oldpassword")} />
                    {errors.oldpassword && (
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "15px",
                        }}
                      >
                        {errors.oldpassword.message}
                      </p>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                rowSpacing={2.75}
                columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
              >
                <Grid item lg={3.98} xs={12}>
                  <Box className={styles.namedetails_input}>
                    <Typography
                      variant="h6"
                      className={`${styles.heading_label} ${styles.newl_label}`}
                    >
                      New password
                    </Typography>
                    <TextField
                      type="text"
                      {...register("password")}
                      error={errors?.password?.message ? true : false}
                    />
                    {errors.password && (
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "15px",
                        }}
                      >
                        {errors.password.message}
                      </p>
                    )}
                  </Box>
                </Grid>

                <Grid item lg={3.98} xs={12}>
                  <Box className={styles.namedetails_input}>
                    <Typography
                      variant="h6"
                      className={`${styles.heading_label} ${styles.newl_label}`}
                    >
                      Confirm new password
                    </Typography>
                    <TextField
                      type="text"
                      {...register("confpassword")}
                      error={errors?.confpassword?.message ? true : false}
                    />
                    {errors.confpassword && (
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "15px",
                        }}
                      >
                        {errors.confpassword.message}
                      </p>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Box className={styles.submit_password_sec}>
                <Button onClick={handleSubmit(onSubmit)}>Save Password</Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default ChnagePassword;
